/**
 * exports HTTP status codes
 */

export default {
  ABORTED: 0,
  NO_CONTENT: 204,
  OK: 200,
  MULTIPLE_CHOICES: 300,
  BAD_REQUEST: 400,
  NOT_FOUND: 404,
};



// WEBPACK FOOTER //
// ./lib/utils/http_status.js